import {
  BusinessOutlined,
  PeopleAltOutlined,
  VisibilityOutlined,
  OutboxOutlined,
} from "@mui/icons-material";
import ManageAccountsOutlined from "@mui/icons-material/ManageAccountsOutlined";
import {lazy} from "react";
import type {Page, PageGroup} from "router/types";
import {ROLE_ADMIN, ROLE_SUPER_ADMIN} from "utils/roles";

const UsersPage = lazy(() => import("pages/account-users/users/UsersPage"));
const AccountsPage = lazy(
  () => import("pages/account-users/account/AccountsPage"),
);
const AccountViewPage = lazy(
  () => import("pages/account-users/account/[id]/view/AccountViewPage"),
);
const AccountUsersPage = lazy(
  () => import("pages/account-users/account-users/AccountUsersPage"),
);
const EmailsPage = lazy(() => import("pages/account-users/emails/EmailsPage"));

const accountUsersRoutes: Array<Page | PageGroup> = [
  {
    segment: "accounts-users",
    title: "Accounts & Users",
    Icon: ManageAccountsOutlined,
    children: [
      {
        segment: "accounts",
        title: "Accounts",
        Icon: BusinessOutlined,
        Component: AccountsPage,
        roles: [ROLE_SUPER_ADMIN],
      },
      {
        segment: "accounts/:id/view",
        title: "Account View",
        Icon: VisibilityOutlined,
        Component: AccountViewPage,
        hideFromNav: true,
        roles: [ROLE_SUPER_ADMIN],
      },
      {
        segment: "account-users",
        title: "Account Users",
        Icon: PeopleAltOutlined,
        Component: AccountUsersPage,
        roles: [ROLE_SUPER_ADMIN, ROLE_ADMIN],
      },
      {
        segment: "users",
        title: "Users",
        Icon: ManageAccountsOutlined,
        Component: UsersPage,
        roles: [ROLE_SUPER_ADMIN],
      },
      {
        segment: "emails",
        title: "Emails",
        Icon: OutboxOutlined,
        Component: EmailsPage,
        roles: [ROLE_SUPER_ADMIN],
      },
    ],
  },
];

export default accountUsersRoutes;
